export default __webpack_public_path__ + "static/media/home.ccd91ae0.svg";